// Les images des plays reprises de Playbook (D-151) : rangées dans la base (play_images), citées par « arceau-img:<id> ».
// Un <img data-aimg="<id>"> reçoit son image après l'affichage (une seule lecture par image, gardée le temps de la page).
import { playImages } from '../lib/api';

export const AIMG = 'arceau-img:';
const BLANK = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
const cache = new Map<string, string>();
const pending = new Map<string, Promise<void>>();

/** L'image d'un play : un lien https tel quel ; une image reprise, une case vide remplie ensuite (data-aimg). */
export const imgSrc = (u: string): { src: string; aimg: string } =>
  (u.startsWith(AIMG) ? { src: cache.get(u.slice(AIMG.length)) ?? BLANK, aimg: u.slice(AIMG.length) } : { src: u, aimg: '' });

/** Remplit les images reprises d'un écran qui vient d'être affiché. */
export async function hydratePlayImages(root: ParentNode): Promise<void> {
  const imgs = [...root.querySelectorAll<HTMLImageElement>('img[data-aimg]')].filter(i => i.dataset.aimg);
  if (!imgs.length) return;
  const want = [...new Set(imgs.map(i => i.dataset.aimg!))].filter(id => !cache.has(id) && !pending.has(id) && /^[0-9a-f-]{36}$/i.test(id));
  if (want.length) {
    const p = playImages(want).then(rows => { for (const r of rows) cache.set(r.id, `data:${r.mime};base64,${r.data}`); }).catch(() => undefined)
      .finally(() => { for (const id of want) pending.delete(id); });
    for (const id of want) pending.set(id, p);
  }
  await Promise.all([...new Set(imgs.map(i => pending.get(i.dataset.aimg!)).filter(Boolean))]);
  for (const i of imgs) { const s = cache.get(i.dataset.aimg!); if (s && i.src !== s) i.src = s; }
}
